/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Inject, Injectable } from '@angular/core';

import { DOCUMENT } from '@angular/common';
import { environment } from '../../../../../../environments/environment';
import { IRedirectService } from './redirect.service.interface';

@Injectable()
export class RedirectService implements IRedirectService {
  private readonly _rootUrl: string;
  private readonly _videoEventPath: string;

  constructor(@Inject(DOCUMENT) private readonly _document: Document) {
    this._rootUrl = environment.config.legacyBaseUrl;
    this._videoEventPath = environment.config.videoEventPath;
    if (!this._videoEventPath.startsWith('/')) {
      this._videoEventPath = `/${this._videoEventPath}`;
    }
    if (!this._videoEventPath.endsWith('/')) {
      this._videoEventPath = `${this._videoEventPath}/`;
    }
  }

  public redirectToUrl(url: string): void {
    this._document.defaultView.location.href = `${this._rootUrl}${url}`;
  }

  public redirectToVideoEventPage(videoEventId: number): void {
    return this.redirectToUrl(`${this._videoEventPath}${videoEventId}`);
  }
}
